import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as actions from '../actions/config';

const initialState = fromJS({
  data: [],
  state: null,
});

const ConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CONFIG_FETCH_START: {
      return state.set('state', fetchingState.FETCHING);
    }
    case actions.CONFIG_FETCH_SUCCESS: {
      return state
        .set('state', fetchingState.LOADED)
        .set('data', fromJS(action.data.results));
    }
    case actions.CONFIG_FETCH_ERROR: {
      return state.set('state', fetchingState.ERROR);
    }
    default: {
      return state;
    }
  }
};

export default ConfigReducer;
